<div class="d-flex flex-column input-group">
  <div class="d-flex flex-column align-items-start" *ngIf="label || titleKey">
    <jhi-bary-title [titleKey]="titleKey" [tooltip]="tooltip" [invalid]="control.invalid && control.touched"></jhi-bary-title>
    <span *ngIf="label" class="small grey-text pb-2">{{ label }}</span>
  </div>
  <div class="d-flex flex-row flex-wrap align-items-stretch {{ justifyContent }} bary-option-group btn-group">
    <label
      mdbBtn
      class="p-0 mx-2 {{ heightCell }} {{ widthCell }} position-relative form-check form-check-inline bary-option-group-item"
      [class.disabled]="option.status === 'disabled'"
      [class.enabled]="option.status === 'enabled'"
      [class.max-width-250px]="options.length === 1"
      [class.active]="option.status === 'selected' || control.value === option.value"
      *ngFor="let option of options; index as i"
      (keyup.enter)="control.setValue(option.value)"
      data-id-cypress="options-selector"
    >
      <input type="radio" class="form-check-input" [value]="option.value" [formControl]="control" [mdbValidate]="true" tabindex="-1" [id]="id + '-' + i" mdbInput />

      <div class="w-100 position-absolute opt-icon w-100 mx-auto" [class.mt-4]="option.libIcon === 'fas'" [class.mt-3]="option.libIcon === 'baryicons'">
        <jhi-bary-icon *ngIf="option.libIcon === 'fas'" [icon]="option.icon" [faDirective]="FAS" size="3x"></jhi-bary-icon>
        <i [class]="'icon ' + option.icon" *ngIf="option.libIcon === 'baryicons'"></i>
      </div>
      <span class="mb-2 px-1 position-absolute text-icon w-100">{{ option.label }}</span>
    </label>
  </div>
  <div class="invalid" *ngIf="control.invalid && (control.touched || control.dirty)">
    <span *ngIf="control.hasError('required')" jhiTranslate="ERROR.REQUIRED_FIELD"></span>
  </div>
</div>
